import styled, { css } from 'styled-components';

import { Container as ArrowButtonContainer } from '../Arrow.styled';

export const Container = styled(ArrowButtonContainer)`
    ${({ theme }) => css`
        width: 100%;
        --button-font-size: 1.125rem;
        --button-padding-y: 1.125rem;

        &&:hover {
            border-radius: 1rem;
        }

        @media ${theme.breakpoints.large.media} {
            --button-font-size: 1.75rem;
            --button-padding-y: 1.75rem;
        }
    `}
`;
